import {constants} from "./module";

export function locationsHover() {
    let timeout;

    $(".our-locations .item").hover(
        function () {
            if(window.innerWidth >= 1200 && !constants.isTouch){
                timeout = setTimeout(() => {
                    $(this).find("address").slideDown();
                }, 350);
            }
        },

        function () {
            if(window.innerWidth >= 1200 && !constants.isTouch){
                clearTimeout(timeout);

                $(this).find("address").slideUp();
            }
        }
    );
}


// WEBPACK FOOTER //
// ./assets/js/modules/locations-hover.js